document.addEventListener('DOMContentLoaded', function() {
  function updateSelectedSellingPlanId() {
    var selectedInput = document.querySelector('.subscription-widget .selling_plan[type="radio"]:checked');
    var hiddenInput = document.querySelector('.selected-selling-plan-id');
    var variantIdElem = document.querySelector('.product-variant-id');
    var oneTimeWidget = document.querySelector('.one-time-widget label');
    var oneTimeRadio = oneTimeWidget ? oneTimeWidget.querySelector('input[type="radio"]') : null;
    var customSelectBox = oneTimeWidget ? oneTimeWidget.querySelector('.custom-select-box') : null;

    if (selectedInput && hiddenInput) {
      hiddenInput.value = selectedInput.value;
    }

    // Update document.product-variant-id
    if (selectedInput && selectedInput.dataset.variant) {
      document.productVariantId = selectedInput.dataset.variant;
      if (variantIdElem) {
        variantIdElem.value = selectedInput.dataset.variant;
      }
    } else if (oneTimeRadio && oneTimeRadio.checked && customSelectBox) {
      document.productVariantId = customSelectBox.value;
      if (variantIdElem) {
        variantIdElem.value = customSelectBox.value;
      }
      if (hiddenInput) {
        hiddenInput.value = '';
      }
    } else {
      document.productVariantId = null;
      if (variantIdElem) {
        variantIdElem.value = '';
      }
      if (hiddenInput) {
        hiddenInput.value = '';
      }
    }

    // Move selected-selling-plan-id input right after variantIdElem
    if (variantIdElem && hiddenInput) {
      variantIdElem.parentNode.insertBefore(hiddenInput, variantIdElem.nextSibling);
    }

    // Update active class on subscription options
    var optionLabels = document.querySelectorAll('.subscription-widget .subscription-option');
    optionLabels.forEach(function(label) {
      label.classList.remove('active');
    });
    if (selectedInput) {
      var parentLabel = selectedInput.closest('.subscription-option');
      if (parentLabel) {
        parentLabel.classList.add('active');
      }
      if (oneTimeWidget) {
        oneTimeWidget.classList.remove('active');
      }
    } else if (oneTimeRadio && oneTimeRadio.checked) {
      if (oneTimeWidget) {
        oneTimeWidget.classList.add('active');
      }
    }

    // Fill price-dollar and price-cents for one-time purchase
    if (oneTimeRadio && oneTimeRadio.checked && customSelectBox) {
      var selectedOption = customSelectBox.options[customSelectBox.selectedIndex];
      var pricePerBottle = selectedOption.getAttribute('data-price-per-bottle') || '';
      var priceParts = pricePerBottle.replace(/[^0-9.]/g, '').split('.');
      var priceDollar = priceParts[0] || '';
      var priceCents = priceParts[1] || '00';
      var priceDollarElem = oneTimeWidget.querySelector('.custom-price .price-dollar');
      var priceCentsElem = oneTimeWidget.querySelector('.custom-price .price-cents');
      if (priceDollarElem) priceDollarElem.textContent = '$' + priceDollar + '.';
      if (priceCentsElem) priceCentsElem.textContent = priceCents;

      // Update saving-badge and total-saving for one-time purchase
      var savingBadgeElem = oneTimeWidget.querySelector('.custom-saving .saving-badge');
      var totalSavingElem = oneTimeWidget.querySelector('.custom-saving .total-saving');
      var bundleSaving = selectedOption.getAttribute('data-bundle-saving-percentage') || '';
      var bulkDiscountType = selectedOption.getAttribute('data-bulk-discount-type') || '';
      var bulkDiscountValue = selectedOption.getAttribute('data-bulk-discount-value') || '';

      if (bulkDiscountType === 'percentage') {
        if (savingBadgeElem) savingBadgeElem.textContent = 'Save ' + bundleSaving + '%';
      } else if (bulkDiscountType === 'fixed-amount') {
        if (savingBadgeElem) savingBadgeElem.textContent = 'Save $' + (bulkDiscountValue / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '!';
      } else {
        if (savingBadgeElem) savingBadgeElem.textContent = 'Market Price';
      }
      // Calculate price per day
      var pricePerDay = '';
      if (pricePerBottle) {
        var priceNum = parseFloat(pricePerBottle.replace(/[^0-9.]/g, ''));
        if (!isNaN(priceNum)) {
          pricePerDay = (priceNum / 30).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
      }
      if (totalSavingElem) totalSavingElem.textContent = pricePerDay ? ('$' + pricePerDay + ' per day') : '';
    }

    // Toggle subscription description visibility
    var descWrapper = document.querySelector('.subscription-description-wrapper');
    if (descWrapper) {
      var subDesc = descWrapper.querySelector('.subscription');
      var oneTimeDesc = descWrapper.querySelector('.one-time');
      if (selectedInput) {
        if (subDesc) subDesc.classList.remove('visually-hidden');
        if (oneTimeDesc) oneTimeDesc.classList.add('visually-hidden');
      } else if (oneTimeRadio && oneTimeRadio.checked) {
        if (subDesc) subDesc.classList.add('visually-hidden');
        if (oneTimeDesc) oneTimeDesc.classList.remove('visually-hidden');
      } else {
        // Default: show subscription, hide one-time
        if (subDesc) subDesc.classList.remove('visually-hidden');
        if (oneTimeDesc) oneTimeDesc.classList.add('visually-hidden');
      }
    }

    // Update frequency span in subscription description
    if (descWrapper) {
      var subDesc = descWrapper.querySelector('.subscription');
      if (subDesc) {
        var freqSpan = subDesc.querySelector('span[data-frequency]');
        var frequencyValue = '';
        if (selectedInput && selectedInput.dataset.frequency) {
          frequencyValue = selectedInput.dataset.frequency;
        } else if (oneTimeRadio && oneTimeRadio.checked && customSelectBox) {
          var selectedOption = customSelectBox.options[customSelectBox.selectedIndex];
          frequencyValue = selectedOption.textContent.split(' ')[0];
        }
        if (freqSpan) {
          freqSpan.textContent = frequencyValue;
        }
      }
    }
  }

  // Initial update
  var oneTimeWidget = document.querySelector('.one-time-widget label');
  var customSelectBox = oneTimeWidget ? oneTimeWidget.querySelector('.custom-select-box') : null;
  var oneTimeRadio = oneTimeWidget ? oneTimeWidget.querySelector('input[type="radio"]') : null;

  // Ensure price info is filled for one-time purchase on first load
  if (oneTimeRadio && customSelectBox) {
    var selectedOption = customSelectBox.options[0];
    var pricePerBottle = selectedOption.getAttribute('data-price-per-bottle') || '';
    var priceParts = pricePerBottle.replace(/[^0-9.]/g, '').split('.');
    var priceDollar = priceParts[0] || '';
    var priceCents = priceParts[1] || '00';
    var priceDollarElem = oneTimeWidget.querySelector('.custom-price .price-dollar');
    var priceCentsElem = oneTimeWidget.querySelector('.custom-price .price-cents');
    if (priceDollarElem) priceDollarElem.textContent = '$' + priceDollar + '.';
    if (priceCentsElem) priceCentsElem.textContent = priceCents;

    // Update saving-badge and total-saving for one-time purchase on load
    var savingBadgeElem = oneTimeWidget.querySelector('.custom-saving .saving-badge');
    var totalSavingElem = oneTimeWidget.querySelector('.custom-saving .total-saving');
    var bundleSaving = selectedOption.getAttribute('data-bundle-saving-percentage') || '';
    var bulkDiscountType = selectedOption.getAttribute('data-bulk-discount-type') || '';
    var bulkDiscountValue = selectedOption.getAttribute('data-bulk-discount-value') || '';

    if (bulkDiscountType === 'percentage') {
      if (savingBadgeElem) savingBadgeElem.textContent = 'Save ' + bundleSaving + '%';
    } else if (bulkDiscountType === 'fixed-amount') {
      if (savingBadgeElem) savingBadgeElem.textContent = 'Save $' + (bulkDiscountValue / 100).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) + '!';
    } else {
      if (savingBadgeElem) savingBadgeElem.textContent = 'Market Price';
    }
    // Calculate price per day
    var pricePerDay = '';
    if (pricePerBottle) {
      var priceNum = parseFloat(pricePerBottle.replace(/[^0-9.]/g, ''));
      if (!isNaN(priceNum)) {
        pricePerDay = (priceNum / 30).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
      }
    }
    if (totalSavingElem) totalSavingElem.textContent = pricePerDay ? ('$' + pricePerDay + ' per day') : '';
  }

  updateSelectedSellingPlanId();

  // Listen for changes on radio inputs
  var radioInputs = document.querySelectorAll('.subscription-widget .selling_plan[type="radio"]');
  radioInputs.forEach(function(input) {
    input.addEventListener('change', updateSelectedSellingPlanId);
  });

  // Listen for changes on custom-select-box in one-time widget
  if (customSelectBox) {
    customSelectBox.addEventListener('change', function() {
      if (oneTimeRadio) {
        oneTimeRadio.checked = true;
      }
      updateSelectedSellingPlanId();
    });
  }

  // Make one-time widget clickable
  if (oneTimeWidget) {
    oneTimeWidget.addEventListener('click', function(e) {
      // Prevent double firing if clicking the select box itself
      if (e.target.classList.contains('custom-select-box')) return;
      if (oneTimeRadio) {
        oneTimeRadio.checked = true;
      }
      updateSelectedSellingPlanId();
    });
  }
});